import { Component, OnDestroy, OnInit } from '@angular/core';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatDialog } from '@angular/material';
import { Observable } from 'rxjs/Observable';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ActivatedRoute, Router } from '@angular/router';
import { fuseAnimations } from '../../../../../../core/animations';
import { AuthenticationService } from '../../../../../services/authentication/authentication.service';
import { DivisionService } from '../../../../../services/divisions/division.service';
import { ShiftService } from '../../../../../services/shifts/shift.service';
import { SweetAlertService } from '../../../../../services/sweet-alert/sweet-alert.service';
import { SchoolYearService } from '../../../../../services/schoool-year/school-year.service';
import { CourseYearService } from '../../../../../services/cour-years/course-year.service';
import { SchoolYear } from '../../../../../models/school-years/school-year';
import { FormBuilder } from '@angular/forms';
import { Location } from '@angular/common';
import { TranslationService } from '../../../../../services/translation/translation.service';
import { CurriculumService } from '../../../../../services/curricula/curriculum.service';
import { environment } from '../../../../../../../environments/environment';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { MY_FORMATS } from '../../../../../const/date-format';

@Component({
    selector: 'fuse-school-schedule-school-year',
    templateUrl: './school-schedule-school-year.component.html',
    styleUrls: ['./school-schedule-school-year.component.scss'],
    providers: [
        { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
        { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
        { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    ],
    animations: fuseAnimations
})
export class SchoolScheduleSchoolYearComponent implements OnInit, OnDestroy {
    @BlockUI('tracker') blockUIList: NgBlockUI;
    public shifts: any[];
    public courseYears: any[];
    public curricula: any[];
    public contador = 0;
    public schoolYear: SchoolYear = new SchoolYear();
    public data: any;

    constructor(private authenticationService: AuthenticationService,
                public dialog: MatDialog,
                private location: Location,
                public divisionService: DivisionService,
                public shiftService: ShiftService,
                private router: Router,
                private schoolYearService: SchoolYearService,
                private route: ActivatedRoute,
                private courseYearService: CourseYearService,
                private fb: FormBuilder,
                private translationService: TranslationService,
                private sweetAlertService: SweetAlertService,
                private curriculumService: CurriculumService) {
    }

    ngOnInit(): void {
        this.blockUIList.start('Cargando datos...');
        this.data = this.route.snapshot.data;
        this.contador = 0;
        this.loadData();
    }
    public loadData() {
        this.shifts = [];
        this.courseYears = [];
        this.schoolYear = new SchoolYear();
        Observable.combineLatest(
            this.shiftService.getAll(),
            this.courseYearService.getAll(),
            this.schoolYearService.getById(this.authenticationService.getAuthData().SchoolYear.Id),
            this.curriculumService.getAll()
        ).subscribe(([shifts, courseYears, schoolYear, curricula]) => {
            //this.shifts = shifts;
            let authData = this.authenticationService.getAuthData()
            this.shifts = shifts.filter(e => {
                if (authData.Shifts.find(s => s.Id === e.Id)) {
                    console.log("******** = " + e.Id + " d = " + e.Description);
                    return {Id: e.Id, Description: e.Description, Checked: false};
                } 
            });

            this.courseYears = courseYears;
            this.curricula = curricula;
            this.courseYears.forEach(e => e.Divisions = []);
            if (schoolYear) {
                this.schoolYear = schoolYear;
            }
            console.log('this.schoolYear', this.schoolYear);
            const observables = [];
            this.shifts.forEach(e => {
                observables.push(this.divisionService.getAllWithShiftId(e.Id, this.authenticationService.getAuthData().SchoolYear.Id));
            });
            Observable.combineLatest(
                observables
            ).subscribe((divisionsByShift) => {
                this.groupDivision(divisionsByShift);
                this.blockUIList.stop();
            });
        });

    }

    ngOnDestroy(): void {
    }

    public groupDivision(divisionsByShift) {
        divisionsByShift.forEach(dbs => {
            const shift = this.shifts.find(s => dbs.shiftId === s.Id);
            shift.divisionsByCourseYear = this.courseYears.map(e => {
                return {
                    CourseYearName: e.CourseYearName,
                    Divisions: [],
                    Id: e.Id
                };
            });
            dbs.divisions.forEach(d => {
                let course = shift.divisionsByCourseYear.find(dbc => dbc.Id === d.CourseYearId);
                if (course === undefined) {
                    course = {
                        Id: d.CourseYearId,
                        CourseYearName: d.CourseYearName,
                        Divisions: []
                    };
                    shift.divisionsByCourseYear.push(course);
                }
                d.IsActive = true;
                course.Divisions.push(d);
            });
        });
    }

    gotoDivisionSchedule(division){
        this.router.navigate(['pages/divisions-schedule/' + division.Id]);
    }

    imprimirTodo(shift, event) {
        window.open(environment.backendUri + 'report/divisionschedule/' + shift.Id + '/' + this.authenticationService.getAuthData().SchoolYear.Id, '_new');
        event.stopPropagation();
        event.preventDefault();
    }

    descargarListadoDocentes(shift, event) {
        const schoolYearId = this.authenticationService.getAuthData().SchoolYear.Id;
        const shiftId = shift.Id;
        window.open(environment.backendUri + 'report/excel/teachers/' + shiftId + '/' + schoolYearId + '/' + shift.Description.charAt(0), '_new');
        event.stopPropagation();
        event.preventDefault();
    }

    gotoDivisionTeachers(division) {
        this.router.navigate(['pages/management/subjectdivisionteacher/' + division.Id]);
    }
}



// WEBPACK FOOTER //
// ./src/app/main/content/pages/management/schoolyear/school-schedule-school-year/school-schedule-school-year.component.ts